import { render, staticRenderFns } from "./TitleEditor.vue?vue&type=template&id=1894f48e"
import script from "./TitleEditor.vue?vue&type=script&lang=js"
export * from "./TitleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1894f48e')) {
      api.createRecord('1894f48e', component.options)
    } else {
      api.reload('1894f48e', component.options)
    }
    module.hot.accept("./TitleEditor.vue?vue&type=template&id=1894f48e", function () {
      api.rerender('1894f48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/TitleEditor.vue"
export default component.exports